import gql from 'graphql-tag';

export const INVITE_URL_EXPIRATION = gql`
  query InviteUrlExpiration($token: String!) {
    inviteUrlExpiration(token: $token)
  }
`;
